import React from 'react';
import "./OverlayWrapper.scss";

const OverlayWrapper = (props) => {
	const { children, alignItems, onClick, id } = props;
	return <div id={id} onClick={onClick} className="overlay-wrapper" style={{ alignItems: alignItems === "top" ? "start" : alignItems }}>{children}</div>;
}

export default OverlayWrapper;